import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {baseURINoPublic} from '../../shared/common-components/AppConstants';

@Injectable()
export class HhgCarrierRateFilingService {
  constructor(private http: HttpClient) {
  }

  private baseURI = '/tmssserver/api/public';
  private apiURI = '/tmssserver/api';
  public countriesObservable: any;
  // private baseURI = 'api/public';

  /**
   * @description gets list of all rate types for HHG
   * @returns {Observable<any>}
   */
  getRateTypes(): Observable<any>  {
    // TODO
    // http://localhost:8380/tmssserver/api/public/ratesbidcycles/getRateTypesForRateBidcycle/HHG/businessType/48/ratesBidcyclesId
    return this.http.get(this.apiURI + '/ratetypes/hhg/businesstype');
  }
  /**
   * @description gets list of all rate types for HHG and for the current bid cycle
   * @returns {Observable<any>}
   */
  getRateTypesByBidCycle(bidcycleId) {
    /*http://localhost:8380/tmssserver/api/public/ratesbidcycles/getRateTypesForRateBidcycle/HHG/businessType/48/ratesBidcyclesId*/
      return this.http.get(this.apiURI + `/ratesbidcycles/getRateTypesForRateBidcycle/HHG/businessType/${bidcycleId}/ratesBidcyclesId`);
  }

  /**
   * @description gets list of all rate types for FRT
   * @returns {Observable<any>}
   */
  getFrtRateTypes(): Observable<any>  {
    return this.http.get(this.apiURI + '/ratetypes/frt/businesstype');
  }

  getFrtRateTypesForSRO(sroMasterId: number): Observable<any>  {
    return this.http.get(this.apiURI + '/ratetypes/frt/businesstype/' + sroMasterId + '/sroMasterId');
  }

  getHhgCarryForwardRateTypes(ratesBidcyclesId): Observable<any> {
    return this.http.get(this.baseURI + `/ratesbidcycles/getRateTypesForRateBidcycle/HHG/businessType/${ratesBidcyclesId}/ratesBidcyclesId`);
  }
  getFrtCarryForwardRateTypes(ratesBidcyclesId): Observable<any> {
    return this.http.get(this.baseURI + `/ratesbidcycles/getRateTypesForRateBidcycle/FRT/businessType/${ratesBidcyclesId}/ratesBidcyclesId`);
  }
  /**
   * @description gets carrier information for the user
   * @returns {Observable<any>}
   */
  getCarrierByUser(): Observable<any>  {
    return this.http.get('/tmssserver/api/user/carrier');
  }

  /* @description gets carrier information for the user
   * @returns {Observable<any>}
   */
  getCarrierIdByUser(): Observable<any>  {
    return this.http.get('/tmssserver/api/user/carrierId');
  }
  /**
   * @description gets carrier approval info for the carrier id
   */
  getCarrierApprovalInfo(carrierId: number): Observable<any> {
    return this.http.get(this.apiURI + '/carrierApprovalInfo/carrierId/' + carrierId);
  }

  getInactiveHHGTSP(): Observable<any> {
    return this.http.get(this.apiURI + '/getallinactivehhgtsp');
  }

  getInactiveFRTTSP(): Observable<any> {
    return this.http.get(this.apiURI + '/getallinactivefrttsp');
  }
  /**
   * @description gets the list of agencies
   */
  getSroMaster(): Observable<any> {
    return this.http.get(this.apiURI + '/ratessromaster/srotypepojo/businesstype/HHG');
  }
  /**
   * @description gets the list of agencies
   */
  getSroMasterByBidCycle(bidCycle: number): Observable<any> {
    // http://localhost:8380/tmssserver/api/public/ratesbidcycles/getSrosForRateBidcyclesHHG/56/ratesBidcyclesId/8/rateTypeId
    return this.http.get(this.apiURI + `/ratesbidcycles/getSrosForRateBidcyclesHHG/${bidCycle}/ratesBidcyclesId`);
  }
  getSroByRateTypeAndBidCycle(rateTypeId, bidCycle) {
    // http://localhost:8380/tmssserver/api/public/ratesbidcycles/getSrosForRateBidcyclesHHG/56/ratesBidcyclesId/8/rateTypeId
    return this.http.get(this.apiURI + `/ratesbidcycles/getSrosForRateBidcyclesHHG/${bidCycle}/ratesBidcyclesId/${rateTypeId}/rateTypeId`);
  }
  /**
   * @description gets the list of states and countries if there are none.
   */
  getAllStateCountries(): Observable<any> {
    if (!this.countriesObservable) {
      this.countriesObservable = this.http.get(this.apiURI + '/statecountry/');
      return this.countriesObservable;
    }
    return this.countriesObservable;
  }
  /**
   * @description validates the origin destination record against the DB
   * @returns {Observable<any>}
   */
  getOriginDestinationValidation (destinationId, originId, carrierId, type): Observable<any> {
    return this.http.get(this.apiURI + `/ratescope/${carrierId}/carrierId/${destinationId}/destId/${originId}/originId/${type}/type`);
  }

  /**
   * @description validates the origin destination record against the DB hhgProcure table
   * @returns {Observable<any>}
   */
  getOriginDestinationProcureValidation (carrierId, destinationId, originId, sroId, rateTypeId): Observable<any> {
    return this.http.get(this.apiURI + `/hhgrates/${carrierId}/carrierId/${destinationId}/destId/${originId}/originId/${sroId}/sroMasterId/${rateTypeId}/rateTypeId`);
  }

  /**
   * @description gets the list of control types
   * @returns {Observable<any>}
   */
  getHHGControlTypes () {
    return this.http.get('/tmssserver/api/ratefileopen/HHG Rate Effective Dates/controltype');
  }

  /**
   * @description gets the list of bid cycles for FRT
   * @returns {Observable<any>}
   */
  getFrtBidCycles (carrierId) {
    return this.http.get(`/tmssserver/api/ratesbidcycles/getBidcyclesForFrt/${carrierId}/carrierId`);
  }

  /**
   * @description gets the list of bid cycles for FRT
   * @returns {Observable<any>}
   */
  getHhgBidCycles (carrierId) {
    return this.http.get(`/tmssserver/api/ratesbidcycles/getBidcyclesForHhg/${carrierId}/carrierId`);
  }

  /**
   * @description gets the list of control types
   * @returns {Observable<any>}
   */
  getControlTypesRateFiling () {
    return this.http.get('/tmssserver/api/ratefileopen/HHG rate Filing/controltype/pending');
  }

  /**
   * @description gets the list of control types
   * @returns {Observable<any>}
   */
  getFRTControlTypes () {
    return this.http.get('/tmssserver/api/ratefileopen/FRT Rate Effective Dates/controltype');
  }

  /**
   * @description gets the list of control types used in TSP initial screen
   * @returns {Observable<any>}
   */
  getFRTControlTypesWithTSPBidCycle () {
    return this.http.get('/tmssserver/api/ratefileopen/FRT Bid Cycle/controltype');
  }

  /**
   * @description saves the online hhg rate
   * @param onlineHhgRatePayload: current online hhg rate object
   * @returns {Observable<any>}
   */
  saveOnlineHhgRate (onlineHhgRatePayload) {
    return this.http.post(this.apiURI + '/hhgrates/saveOnlineHhgRate', onlineHhgRatePayload);
  }

  /**
   * @description gets the status of particualar carrier
   * @param carrierId: Id of current carrier
   * @returns  Accepted or Rejected status alogn with the whole object
   */
  getCarrierStatus(carrierId) {
    return this.http.get(baseURINoPublic + `/hhgcarryforward/${carrierId}/carrierId`);
  }

  /**
   * @description gets the list of SRO's for the selected rate type Id
   * @param rateTypeId: selected rate type
   * @returns returns list of sro's
   */
  getSroByRateType(rateTypeId) {
    return this.http.get(this.apiURI + `/ratetypessro/${rateTypeId}/rateTypeId`);
  }

  /**
   * @description gets the carry forward status of the current carrier for HHG
   * @returns carry forward object
   * @param carrierId
   * @param controlId
   */
  getHhgCarryForwardStatus(carrierId, ratesBidcyclesId) {
    return this.http.get(baseURINoPublic + `/hhgcarryforward/${carrierId}/carrierId/${ratesBidcyclesId}/ratesBidcyclesId`);
  }

  /**
   * @description gets the carry forward status of the current carrier for FRT
   * @returns carry forward object
   * @param carrierId
   * @param controlId
   */
  getfrtCarryForwardStatus(carrierId, ratesBidcyclesId) {
    return this.http.get(baseURINoPublic + `/frtcarryforward/${carrierId}/carrierId/${ratesBidcyclesId}/ratesBidcyclesId`);
  }
  /**
   * @description gets the number of records per cycle
   * @param payload
   * @param carrierId: current carrier id
   * @param controlId: latest control id
   * @param rateTypeId: selected rate type id
   * @returns {Observable<Object>}: returns number of records from rates_hhg table
   */
  getHhgRecordsPerCycle(payload, carrierId, ratesBidcyclesId, rateTypeId?) {
    return this.http.post(this.apiURI + `/rateshhg/${carrierId}/carrierId/${ratesBidcyclesId}/ratesBidcyclesId/${rateTypeId}/rateTypeId`, payload);
  }

  /**
   * @description gets the number of records per cycle
   * @param payload
   * @param carrierId: current carrier id
   * @param controlId: latest control id
   * @param rateTypeId: selected rate type id
   * @returns {Observable<Object>}: returns number of records from rates_hhg table
   */
  getFRTRecordsPerCycle(payload, carrierId, ratesBidcyclesId, rateTypeId?) {
    return this.http.post(this.apiURI + `/ratesfrt/${carrierId}/carrierId/${ratesBidcyclesId}/ratesBidcyclesId/${rateTypeId}/rateTypeId`, payload);
  }

  /**
   * @description saves the status of HHG carry forward status.
   * @param payload
   * @returns {Observable<Object>}
   */
  saveHhgCarryForward(payload) {
    return this.http.post(baseURINoPublic + `/hhgcarryforward/saveHhgCarryForward`, payload);
  }

  /**
   * @description returns post call to accept hhg carry forward and to initiate the batch processing
   * @param payload
   * @returns {Observable<Object>}
   */
  rejectFrtCarryForward(payload) {
    return this.http.post(baseURINoPublic + `/frtcarryforward/rejectFrtCarryForward` , payload);
  }

  /**
   * @description returns post call to accept hhg carry forward and to initiate the batch processing
   * @param rateTypeId
   * @param sroMasterId
   * @param payload
   * @returns {Observable<Object>}
   */
  acceptCarryForward(rateTypeId, sroMasterId, payload) {
    return this.http.post(baseURINoPublic + `/hhgcarryforward/acceptHhgCarryForward/${rateTypeId}/ratetypeId/${sroMasterId}/sroMasterId` , payload, {responseType: 'text' as 'json'});
  }

  /**
   * @description returns post call to accept hhg carry forward and to initiate the batch processing
   * @param rateTypeId
   * @param sroMasterId
   * @param payload
   * @returns {Observable<Object>}
   */
  acceptFrtCarryForward(rateTypeId, sroMasterId, payload) {
    return this.http.post(baseURINoPublic + `/frtcarryforward/acceptFrtCarryForward/${rateTypeId}/ratetypeId/${sroMasterId}/sroMasterId` , payload, {responseType: 'text' as 'json'});
  }

  /**
   * @description downloads the HHG template
   */
  getHhgTemplateFile(rateTypeId, sroId, carrierId,rateBidcyclesId,rfspCarrierId) {
    return this.http.get(this.apiURI + `/srotemplate/hhg/${rateTypeId}/rateTypeId/${sroId}/sroMasterId/${carrierId}/carrierId/${rateBidcyclesId}/rateBidcyclesId/ ${rfspCarrierId}/rfspCarrierId`,{responseType: 'text' as 'json'});

  }
  /**
   * @description gets the tsp status for FRT
   */
  getFrtTspStatus(carrierId): Observable<any> {
    return this.http.get(this.apiURI + `/ratestspparticipation/validateParticipation/${carrierId}/carrierId`, {responseType: 'text' as 'json'});
  }
  /**
   * @description accepts/rejects the tsp status for FRT 0 for accept and 1 for reject
   */
  acceptRejectFrtTsp(carrierId, controlId, acceptance) {
    return this.http.post(this.apiURI + `/ratestspparticipation/createTspParticipation/${carrierId}/carrierId/${controlId}/controlId/${acceptance}/acceptance`, '', {responseType: 'text' as 'json'});
  }
  /**
   * @description FRT gets the current FRT bid cycle
   */
  getCurrentFrtBidCycleInformation() {
    return this.http.get(this.apiURI + '/ratestspparticipation/currentFrtBidCycle');
  }
  /**
   * @description FRT gets the current FRT bid cycle
   */
  getFrtBidCycleAgencies(carrierId, ratesBidcyclesId) {
    return this.http.get(this.apiURI + `/ratesbidcycles/getSrosForRateBidcyclesFRT/${ratesBidcyclesId}/ratesBidcyclesId/${carrierId}/carrierId`);
  }
  getFrtCarryOverSros(ratesBidcyclesId, carrierId) {
    // http://localhost:8380/tmssserver/api/public/ratesbidcycles/getSrosForRateBidcyclesFRT/22/ratesBidcyclesId/5/carrierId
    return this.http.get(this.apiURI + `/ratesbidcycles/getSrosForRateBidcyclesFRT/${ratesBidcyclesId}/ratesBidcyclesId/${carrierId}/carrierId`);
  }

  getHhgBidCycleAgencies(ratesBidcyclesId) {
    return this.http.get(this.apiURI + `/ratesbidcycles/getSrosForRateBidcyclesHHG/${ratesBidcyclesId}/ratesBidcyclesId`);
  }

  getRateCountForAllSros(ratesBidcyclesId, carrierId): Observable<any>{
    return this.http.get(this.apiURI + `/frtcarryforward/getRatesForAllSrosFRT/${ratesBidcyclesId}/ratesBidcyclesId/${carrierId}/carrierId`);
  }

  getRateCountForEachSro(ratesBidcyclesId, carrierId,sroMasterIdList): Observable<any>{
    return this.http.get(this.apiURI + `/frtcarryforward/getRatesForEachSroFRT/${ratesBidcyclesId}/ratesBidcyclesId/${carrierId}/carrierId/${sroMasterIdList}/sroMasterIdList`);
  }
}

